<template>
    <div id="customerFollow">
        <!-- <van-nav-bar title="跟进" fixed placeholder left-arrow>
      <a @click="$router.back()" slot="left">
        <i class="iconfont iconfanhuianniu"></i>
      </a>
    </van-nav-bar> -->
        <van-form ref="form" @submit="onSubmit" input-align="right">
            <van-field readonly clickable name="status" :value="form.statusName" label="跟进状态" placeholder="点击选择>" @click="showStatus = true" :rules="[{ required: true, message: '请选择跟进状态' }]" />
            <van-field v-if="form.status == 103" readonly clickable name="takeLookDate" :value="form.takeLookDate.slice(0,16)" label="预约看房时间" placeholder="点击选择>" @click="showDate = true" :rules="[{ required: true, message: '请选择时间' }]" />
            <van-field name="reason" label="原因" v-if="form.status == 108">
                <template #input v-if="form.status == 108">
                    <van-checkbox-group v-model="form.reason" @change="form.otherRemark = ''" direction="horizontal">
                        <van-checkbox v-for="item in reasonsList" :key="item.value" :name="item.value" shape="square">{{item.label}}</van-checkbox>
                    </van-checkbox-group>
                </template>
            </van-field>
            <van-field v-if="form.reason.indexOf(100) !== -1" v-model="form.otherRemark" rows="2" autosize label="具体原因" type="textarea" maxlength="50" placeholder="请输入具体原因" show-word-limit :rules="[{ required: true, message: '请输入具体原因' }]" />
            <van-field v-model="form.remark" rows="2" autosize label="跟进备注" type="textarea" maxlength="50" placeholder="请输入跟进备注" show-word-limit />
            <!-- <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">保存</van-button>
            </div> -->
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" :loading="saveLoad" :disabled="saveLoad" native-type="submit">保存</van-button>
            </div>
        </van-form>
        <!-- 跟进状态 -->
        <van-popup v-model="showStatus" position="bottom">
            <van-picker show-toolbar :columns="trackRecordList" value-key="desc" @confirm="item => { if(!item)return;form.takeLookDate = '';form.reason = [];form.statusName=item.desc;form.status=item.code;showStatus=false }" @cancel="showStatus = false" />
        </van-popup>
        <!-- 时间 -->
        <van-popup v-model="showDate" position="bottom">
            <van-datetime-picker type="datetime" @confirm="item => { form.takeLookDate = formatDatetime(item);showDate = false }" @cancel="showDate = false" :min-date="new Date()" />
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { requestChildStatus, requestCustomerTrackrecord } from "@/api";
import { formatDate, formatDatetime } from "@/utils/index";
export default {
    name: "customerFollow",
    data() {
        return {
            form: {
                reason: [],
                otherRemark: "",
                takeLookDate: "",
                remark: ""
            },
            showStatus: false,
            trackRecordList: [],
            showDate: false,
            saveLoad: false,
            reasonsList: [
                { label: "价格贵", value: 1 },
                { label: "距离远", value: 2 },
                { label: "环境差", value: 3 },
                { label: "产品差", value: 4 },
                { label: "其他", value: 100 }
            ]
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList"
        ])
    },
    created() {
        this.form.customerId = this.$route.query.id;
        this.getTrackRecord();
    },
    mounted() {},
    methods: {
        //跟踪记录状态
        getTrackRecord() {
            let param = {
                status: this.$route.query.status,
                lastStatus:
                    this.$route.query.status == 109
                        ? this.$route.query.lastStatus
                        : null,
                customerId:this.form.customerId
            };
            requestChildStatus(param).then(res => {
                this.trackRecordList = res.data;
            });
        },
        onSubmit() {
            this.form.trackRecordReasons = [];
            this.form.reason.forEach(d => {
                this.form.trackRecordReasons.push({
                    type: d,
                    remark: d == 5 ? this.form.otherReamrk : ""
                });
            });
            this.saveLoad = true;
            requestCustomerTrackrecord(this.form)
                .then(res => {
                    this.$toast.success({
                        message: "添加成功",
                        forbidClick: true,
                        onClose: () => {
                            this.$router.back();
                        }
                    });
                    this.saveLoad = false;
                })
                .catch(err => {
                    this.saveLoad = false;
                });
        },
        formatDate(date) {
            return formatDate(date);
        },
        formatDatetime(date) {
            return formatDatetime(date);
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
/deep/.van-field__error-message {
    text-align: right;
}
/deep/.van-checkbox--horizontal {
    margin-bottom: 0.32rem;
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
</style>
